<template>
  <div class="section-main__warp">
    <!-- 创建布控组件 -->
    <!-- start @description: 右侧创建布控面板!-->
    <ioc-drawer
      :width="460"
      :title="$t('carPatrol.title.editControl')"
      :show-close="false"
      v-model="dialogVisible"
      :before-close="handleClose"
      :custom-class="drawerControl"
      :modal="false"
    >
      <patrol-panel ref="patrol" @submit="handleSubmit"></patrol-panel>
    </ioc-drawer>
    <!-- 布控摄像机组 -->
    <app-camers-group @change="carameChange" @cameraScatterPoint="cameraScatterPoint" ref="appCamersGroup" :isUpdate="true"></app-camers-group>
    <!-- start @description: 引入IGIS地图 !-->
  </div>
</template>

<script>
import { api } from '../api'
import { Dic, Log } from '$utils'
export default {
  components: {
    // 摄像机组组件
    AppCamersGroup: () => import('@components/app-camera-group'),
    // 布控维护面板
    PatrolPanel: () => import('../components/PatrolPanel')
  },
  data() {
    return {
      // 判断进入页面的标题
      // 默认抽屉关闭状态
      dialogVisible: false,
      formData: {},
      drawerControl: 'drawer-control',
      drawPoint: [],
      iconObj: null,
      igisMap: null,
      scatteIconObj: null
    }
  },
  created(){
    const code = this.$route.query.code || {}
    const self = this;
    // 查询详情数据
    this.$fetch(api.task.queryVehicleTaskDetails, {
      code: code
    }).then(response => {
      if (response.success) {
        const data = response.returnObj[0];
        this.formData = data
        this.$nextTick(() => {
          self.$refs["patrol"].loadData(data)
          self.$refs["appCamersGroup"].getTreeData(data.bayonetList, true)
        }) 
      }
    })
  },
  mounted() {
    Log.debug('传递过来的参数', this.formData)


    // 布控级别进行转换
    // param.alarmLevel = _.toNumber(param.alarmLevel)

   // Object.assign(this.formData, param)

    this.dialogVisible = true
  },
  methods: {
    /*
     *@name: 摄像机撒点
     *@param:{type} 
     *@description:
     *@return:
     *@author: panlua
     *@date: 2019-06-22 11:23:20
    */
    cameraScatterPoint (cameraArr) {
      let cameraArrPoint = []
      let _self = this
      _self.$nextTick(() => {
        _self.igisMap = _self.$refs.igis.map
        _self.scatteIconObj = new window.iGis.layers.IconLayer({
          gisMapObj: _self.igisMap,
          isRef: true,
          isHover: true,
          layerOptions: {
            isBox: false,
            anchor: [10, -10]
          }
        })
        cameraArr.forEach(item => {
          cameraArrPoint.push({
            src: 'images/map/resource/camera.png',
            label: item.deviceName,
            coord: [item.longitude,item.latitude]
          })
        })
        _self.scatteIconObj.setData(cameraArrPoint, 0);
      })
    },
    /*
     *@name: 摄像机回调事件
     *@param:{type} 
     *@description:
     *@return:
     *@author: panlua
     *@date: 2019-05-10 09:42:55
    */
    carameChange(data = [], cameraArr = []){
      const bayonetList = []
      let filterArr = data.map(item => {
        return item.code
      })
      Array.from(new Set(filterArr)).forEach(item => {
        bayonetList.push({
          bayonetCode: item
        });
      })
      this.formData.bayonetList = bayonetList;
      this.igisMap = this.$refs.igis.map
      const _self = this
      this.iconObj && this.igisMap.removeLayer(this.iconObj)
      this.iconObj = new window.iGis.layers.IconLayer({
        gisMapObj: _self.igisMap,
        isRef: true,
        isHover: true,
        layerOptions: {
          isBox: false,
          anchor: [10, -10]
        }
      })
      _self.drawPoint.length = 0
      cameraArr.forEach(item => {
        _self.drawPoint.push({
          src: 'images/map/resource/camera_red.png',
          label: item.deviceName,
          coord: [item.longitude,item.latitude]
        })
      })
      this.iconObj.setData(_self.drawPoint, 0);
    },
    /*
     *@name:取消-返回到布控列表页面
     *@param:{type}
     *@description:返回到布控列表页面
     *@return:无
     *@author: zhengff
     *@date: 2019-05-02 22:06:00
     */
    handleClose() {
      this.$router.push({
        path: '/view/Index',
        name: 'carPatrol'
      })
    },
    inIndexPage() {
      this.$router.push({
        path: '/view/Index',
        name: 'carPatrol'
      })
    },
    /*
     *@name:提交功能
     *@param:{type}
     *@description:
     *@return:
     *@author: zhengff
     *@date: 2019-04-30 18:04:39
     */
    handleSubmit() {
      if (!this.formData.bayonetList.length) {
        this.$message.warning('选择布控摄像机组')
        return false
      } else if(typeof this.formData.bayonetList[0] != 'object'){
        let bayonetListArr = [];
           this.formData.bayonetList.map(item => {
                bayonetListArr.push({
                    bayonetCode: item
                });
          });
          this.formData.bayonetList = bayonetListArr;
      }
      let data = this.$refs['patrol'].ruleForm
      let timeList = data.timeList
      let newTimeList = []
      let param = {
        code: this.formData.code,
        name: data.controlName,
        startDate: data.startDate,
        endDate: data.endDate,
        alarmLevel: data.alarmLevel,
        // bayonetList: [{
        //   bayonetCode: "432f4f7e-d4bd-4f05-be2a-3f0b1df45ad8"
        // }],
        bayonetList: this.formData.bayonetList,
        groupList: data.groupList
      }
      if (timeList.length === undefined) {
        for (let i in timeList) {
          let t = i
          timeList[i].forEach(item => {
            console.log(item)
            let startTime = item.startTime.split('')
            let endTime = item.endTime.split('')
            newTimeList.push({
              startTime: startTime[0] + startTime[1] + ':' + startTime[2] + startTime[3] + ':' + startTime[4] + startTime[5],
              endTime: endTime[0] + endTime[1] + ':' + endTime[2] + endTime[3] + ':' + endTime[4] + endTime[5],
              day: i
            })
          })
        }
      }
      param.timeList = timeList.length === undefined ? newTimeList : timeList
      console.log(param)
      this.$fetch(api.task.updateVehicleTask, param)
        .then(response => {
          if (!response.success) {
            this.$message.error(response.msgContent)
            return
          }
          this.$message.success('修改布控任务成功')
          this.inIndexPage()
        })
        .catch(() => {
          this.$message.error('修改失败')
        })
    }
  }
}
</script>
<style>
.section-main__content {
  position: relative;
}
</style>
